import { apiSlice } from "../api/apiSlice";
import { userLoggedIn } from "./authSlice";

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStudents: builder.query({
      query:()=>`/users?role=student`
    }),
    studentRegister: builder.mutation({
      query: (data) => ({
        url: "/register",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;

          localStorage.setItem("AUTH",
            JSON.stringify({
              accessToken: result.data.accessToken,
              user: result.data.user,
            })
          );

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: result.data.user,
            })
          );
        } catch (err) {
        }
      },
    }),
    
    login: builder.mutation({
      query: ({data, role}) => ({
        url: "/login",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          const role = arg?.role || 'student';
          const { role:userRole = '' } = result?.data?.user || {};

          if (userRole !== role) {
            return;
          }
          if (result)
            localStorage.setItem("AUTH",
              JSON.stringify({
                accessToken: result.data.accessToken,
                user: result.data.user,
              })
            );

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: result.data.user,
            })
          );
        } catch (err) {
        }
      },
      // transformResponse: (response, meta, arg) => {
      //   console.info('response',response)
      //   console.info('meta',meta)
      //   console.info('arg',arg)
      //   return {isError:true, error:'Helllo world'}
      // },
      // transformErrorResponse: (response, meta, arg) => {
      //   console.info('response',response)
      //   console.info('meta',meta)
      //   console.info('arg',arg)
      //   return {isError:true, error:'Helllo world'}
      // },
      
    }),

  }),
});

export const {useGetStudentsQuery, useLoginMutation, useStudentRegisterMutation } = authApi;
